import { z } from "zod";
import type { ReviewCycleAction } from "./reviewCycleSchemas.ts";

export const CycleAudienceEntryKinds = ["member", "segment", "team"] as const;

export type CycleAudienceEntryKind = (typeof CycleAudienceEntryKinds)[number];

const CycleAudiencePickableKinds = ["member", "segment"] as const satisfies readonly CycleAudienceEntryKind[];

const CycleAudienceParticipantSchema = z.object({
    kind: z.enum(CycleAudienceEntryKinds),
    id: z.string().min(1)
});

export type CycleAudienceParticipant = z.infer<typeof CycleAudienceParticipantSchema>;

const CycleAudiencePickableParticipantSchema = z.object({
    kind: z.enum(CycleAudiencePickableKinds),
    id: z.string().min(1)
});

export const CycleAudienceActionSchemas = [
    z.object({ type: z.literal("UpdateReviewCycleAudienceScopeAction"), useAllOrganization: z.boolean() }),
    z.object({ type: z.literal("IncludeReviewCycleParticipantAction"), participant: CycleAudiencePickableParticipantSchema }),
    z.object({ type: z.literal("ExcludeReviewCycleParticipantAction"), participant: CycleAudiencePickableParticipantSchema }),
    z.object({ type: z.literal("RemoveReviewCycleParticipantAction"), participant: CycleAudienceParticipantSchema })
] as const;

export type CycleAudienceAction = z.infer<(typeof CycleAudienceActionSchemas)[number]>;

export function isCycleAudienceAction(action: ReviewCycleAction): action is CycleAudienceAction {
    return CycleAudienceActionSchemas.some(schema => schema.shape.type.value === action.type);
}

const CycleAudienceEntrySchema = z.object({
    kind: z.enum(CycleAudienceEntryKinds),
    id: z.string(),
    name: z.string().nullable(),
    imageUrl: z.string().optional()
});

export type CycleAudienceEntry = z.infer<typeof CycleAudienceEntrySchema>;

export const CycleAudienceSchema = z.object({
    everyone: z.boolean(),
    included: z.array(CycleAudienceEntrySchema),
    excluded: z.array(CycleAudienceEntrySchema)
});

export type CycleAudience = z.infer<typeof CycleAudienceSchema>;
